import React, { useEffect, useState } from 'react';

import { RideGrid, RideGlGiftOutline } from '@rimac-seguros/ride-system-components';

import { useAppContext } from '../../../AppProvider';

import './styles.scss';

export const BannerCampaignDays = () => {
  const [experimentData, setExperimentData] = useState();

  const { dispatch } = useAppContext();

  useEffect(() => {
    window.showBannerCampaignDays = () => {
      if (window.ExperimentCampaignDays?.isActive) {
        setExperimentData(window.ExperimentCampaignDays);
        dispatch({ type: 'SET_EXP_CAMPAIGN_DAYS' });
      }
    };
  }, []);

  if (!experimentData?.limitDate) return null;

  return (
    <section className="banner-campaign-days">
      <RideGrid>
        <div className="banner-campaign-days_content">
          <div className="box-svg">
            <RideGlGiftOutline size="2x-large" fill="var(--ride-sys-color-glyph-inverse)" />
          </div>
          <p>¡Compra en Días RIMAC y participa por un vale de S/500 cada día!</p>
        </div>
      </RideGrid>
    </section>
  );
};
